export default "__VITE_ASSET__B1YwC$9u__"